module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA0CAMAAADc48pLAAAASFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACrhKybAAAAF3RSTlMAzigSF+rfp4EuhaKMMeTH767WNnYeld3gI7UAAACuSURBVDjLtY/LFsIgDEQDWGxrBenD/P+feo6LziYkCqfZztzLQNW7LYG0C45d0PLMzDloPKNRzZmd13PmUdyPvASdv4v8Cp5a+Ij8Ej7/vP/RxDvwat7PlyZ+7Xv/iH28H878TdJtfN5O4j2hGEl2vNAwHXZjbnVMaCwVh7nUJ9thLfXRckz2jmi9Mg39Dg/H3O4wf2u/kv5w7MbStJHqSF4K4YiHFMEBXm6Ub/4Bnasp1/Kq6XkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/return.png
// module id = ahJr
// module chunks = 1